import React from 'react';
import SignUpModal from 'login/components/SignUp/SignUpModal.jsx';
import SignInModal from 'login/components/SignIn/SignInModal.jsx';
import ForgetPasswordModal from 'login/components/ForgetPassword/ForgetPasswordModal.jsx';
import ResetPasswordModal from 'login/components/ResetPassword/ResetPasswordModal.jsx';
import SaveConfirmationModal from 'login/components/SaveConfirmation/SaveConfirmationModal.jsx';
import ProfileModal from 'login/components/Profile/ProfileModal.jsx';
import PropTypes from 'prop-types';

const Modals = ({ hasAdobeTagging }) => {
    return (
        <>
            <SignUpModal hasAdobeTagging={hasAdobeTagging} />
            <SignInModal hasAdobeTagging={hasAdobeTagging} />
            <ForgetPasswordModal />
            <ResetPasswordModal />
            <SaveConfirmationModal />
            <ProfileModal />
        </>
    );
};

Modals.defaultProps = {
    hasAdobeTagging: false,
};

Modals.propTypes = {
    hasAdobeTagging: PropTypes.bool,
};

Modals.displayName = 'Modals';

export default Modals;
